import { RichText as RichTextComponent } from "@brightagency/headstart-common";
import React, { FC } from "react";
import { LinkInterceptor } from "../../utils/hooks";

export const RichText: FC<{ content: string }> = props => {
    return (
        <LinkInterceptor>
            <RichTextComponent dangerouslySetInnerHTML={{ __html: props.content }} />
        </LinkInterceptor>
    );
};

export const RichTextJsx: FC = props => {
    return (
        <LinkInterceptor>
            <RichTextComponent>{props.children}</RichTextComponent>
        </LinkInterceptor>
    );
};
